import functions from '../functions';
import { list } from './list';

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 12,
        language: functions.getLang(1),
        arrivalDateFrom: '',
        destination: '',
        countryId: '',
        objectGroupId: 6,
        guests: '0,0',
        hasArrival: 2,
        hasDiscount: null,
        tagCategoryId: '',
        tagCategoryIds: '',
        sortBy: '11:DESC'
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: '',
        //sortBy: null, 
        objectName: null,
        hasDiscount: null,
    },
    filterParamDefaults: {
        tagCategoryId: '',
        transportationType: '',
        objectName: null,
        hasDiscount: null,
    },
    mainFields: ['arrivalDateFrom', 'destination', 'sortBy', '_page'],
    init() {
        this.$form = $('.search-form.search-travel');
        this.form = this.$form[0];

        if(! this.form || this.defaults.objectGroupId != this.$form.attr('data-objectgroupid')) {
            return;
        }

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;

        this.listURL = this.$form.last().attr('data-listurl');
        this.defaults.objectGroupId = this.$form.last().attr('data-objectgroupid');
        this.defaults.transportationType = this.$form.attr('data-transportationtype');
        this.defaults.tagCategoryId = this.$form.attr('data-tagCategoryId') || '';


        // OLD
        // this.defaults.countryId = this.defaults.destination = this.$form.last().attr('data-countryid');

        this.defaults.destination = this.$form.attr('data-destination') ? this.$form.attr('data-destination') : this.defaults.countryId;

        this.$filter = $('.search-filter');

        this.filterParams.tagCategoryId = this.$form.last().attr('data-tagcategoryid');
        this.filterParams.tagCategoryIds = this.$form.last().attr('data-tagcategoryids');
        this.filterParams.hasDiscount = this.$form.attr('data-hasdiscount');

        this.$filter && (this.filterParams = functions.getFormData(this.$filter));
        
        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            this.isHome = $target.attr('data-ishome') || this.isHome;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.countryId = this.params.destination = $target.attr('data-countryid');
                this.params.perPage = $target.attr('data-perpage') || this.defaults.perPage;
            }

            this.params = $.extend({}, this.defaults, functions.getFormData($target), this.$filter && functions.getFormData(this.$filter));
            this.params._page = this.defaults._page;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.tagCategoryId = $target.attr('data-tagcategoryid');
                this.params.tagCategoryIds = $target.attr('data-tagcategoryids');
                this.params.hasDiscount = $target.attr('data-hasdiscount');

                this.params.destination = ! this.params.destination && this.$form.attr('data-destination') ? this.$form.attr('data-destination') : this.params.destination;
                
                this.params = functions.cleanParams(this.params, this.defaults);

                if (this.params.destination == this.defaults.destination) this.defaults.destination = '';
                if (this.params.dynamicPackage) delete this.params['excludeCountryIds'];
                
                location = $target.attr('data-listurl') + '#' + $.param(this.params);
            } else {
                
                functions.setUrlData(this.params, true, true, this.defaults);
            }

        });

        if(! this.isHome) {

            this.getParams();           
            functions.setFormData(this.form, this.params);
            this.params.guests = $('[name=guests]').val();
            this.find(this.params);
        } else {
            functions.setFormData(this.form, this.defaults);
        }

        if ( this.isHome ) {
            return;
        }

        
        this.$filter && functions.setFormData(this.$filter[0], this.params);
        this.$filter.on('change', e => {

            const $currentTarget = $(e.currentTarget);
            this.filterParams = $.extend({}, this.filterParamDefaults, functions.getFormData(this.$filter));
            this.params = functions.getFormData(this.$form);
            const target = $(e.target)[0];
            this.params._page = this.defaults._page;

            if(target && target.name == 'transportationType') {

                $('[name="transportationType"]').each((index, item) => {
                    if(target.id != item.id) {
                        $(item).prop('checked', false);
                    }
                });

                this.filterParams.transportationType = target.checked ? target.value : this.defaults.transportationType;
            }

            this.getParams();
            this.params = $.extend({}, this.defaults, this.params, this.filterParams);

            Object.keys(this.params).forEach(key => {
                if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
            });
            
            functions.setUrlData(this.params, true, true, this.defaults);
        });

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $('[name="tagCategoryId"]').on('change', e => {
            // this.params._page = this.defaults._page;
            // this.getParams();
            this.setTagCategoryId();
            // this.find(this.params);

            // functions.setUrlData(this.params, true, true);
        });
        $('[name="hasDiscount"]').on('change', e => {
            this.params._page = this.defaults._page;
            this.getParams();
            this.params.hasDiscount = e.currentTarget.checked ? $(e.currentTarget).val() : null;
            
            Object.keys(this.params).forEach(key => {
                if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
            });
            functions.setUrlData(this.params, true, true, this.defaults);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.setTagCategoryId();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;
        });
    },
    getParams() {      
        this.params = list.getParams(this.params, this.defaults, this.filterParams);

        if(this.params.arrivalDateFrom) {
            
            let dateFrom = new Date(this.params.arrivalDateFrom);
            let month = dateFrom.getMonth() + 1;
            
            let lastDateOfMonth = new Date(dateFrom.getFullYear(), month, 0);
            this.params.arrivalDateTo = lastDateOfMonth.getFullYear() + '-' + (lastDateOfMonth.getMonth() + 1) + '-' + lastDateOfMonth.getDate();
        }
    },
    setTagCategoryId() {
        let tagCategoryIds = [];
        $('[name="tagCategoryId"]').each((index, target) => {
            const $target = $(target);
            if($target[0].checked) {
                tagCategoryIds.push($target.val());
            }
        });
        this.params.tagCategoryId = tagCategoryIds.join(",");
    },
    find(params) {
        list.find(params).then((response) => {
            list.findDone(response);

            // register paginate        
            $('[data-page]').on('click', e => {
                e.preventDefault();
                let page = +$(e.currentTarget).attr('data-page');
                if (page != this.params._page) {
                            this.params._page = page;
                        }
                
                        functions.setUrlData(this.params, true, false, this.defaults);
            });
    
            this.$sortBy = $('[name="sortBy"]');
            this.sortBy = this.$sortBy[0] ? this.$sortBy[0] : null;
    
            if(this.sortBy && this.params.sortBy) {
                this.$sortBy.each((index, elem) => {
                    if(elem.type === 'checkbox') {
                        elem.checked = elem.value === this.params.sortBy;
                    } else if(elem.type === 'select-one') {
                        $(elem).val(this.params.sortBy);
                    }
                });
            }
    
            this.$sortBy.on('change', e => {

                let data = functions.getFormData($(e.currentTarget));
                data.sortBy = data.sortBy ? data.sortBy : '11:DESC';
                this.params = $.extend(this.params, this.getParams(), data);
                functions.setUrlData(this.params, true, true, this.defaults);
            });
            // LOZAD
            window.observer.observe();
        });
    },

};